import React, { useState, useEffect, useContext } from "react";
import { useSize } from "@umijs/hooks";
import SwiperCore, { SwiperOptions, Autoplay, Mousewheel } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.css";
import { DataContext } from "App";
import dayjs from "dayjs";
import { Link } from "react-router-dom";
import { useQuery } from "utils/hook";
import Adcodes from "assets/json/adcode.json";

SwiperCore.use([Autoplay, Mousewheel]);

const swiperParams: SwiperOptions = {
  direction: "vertical",
  loop: true,
  loopedSlides: 1,
  slidesPerView: "auto",
  mousewheel: true,
  autoplay: {
    delay: 1800,
    disableOnInteraction: false,
  },
};

const getTime = () => dayjs().format("YYYY-MM-DD HH:mm:ss");

const AppHeader: React.FC = () => {
  const appData = useContext(DataContext);
  const [time, setTime] = useState(getTime());
  const query = useQuery();
  const mapName = (query.get("mapName") as keyof typeof Adcodes) || "全国";

  const [{ width: w = 0, height: h = 0 }, ref] = useSize<HTMLDivElement>();
  const [{ width: tw = 0 }, titleRef] = useSize<HTMLDivElement>();

  useEffect(() => {
    const timer = setInterval(() => {
      setTime(getTime());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <header className="relative" ref={ref}>
      <svg
        className="absolute top-0 left-0"
        width={w}
        height={h}
        viewBox={`0 0 ${w} ${h}`}
      >
        <defs>
          <linearGradient id="fillColor" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop
              offset="25%"
              style={{ stopColor: "rgba(127, 106, 213, .01)" }}
            />
            <stop
              offset="100%"
              style={{ stopColor: "rgba(127, 106, 213, .5)" }}
            />
          </linearGradient>
          <linearGradient id="strokeColor" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop
              offset="0%"
              style={{ stopColor: "rgba(127, 106, 213, .2)" }}
            />
            <stop
              offset="12%"
              style={{ stopColor: "rgba(127, 106, 213, 1)" }}
            />
            <stop offset="60%" style={{ stopColor: "rgba(61, 66, 191, 1)" }} />
            <stop
              offset="100%"
              style={{ stopColor: "rgba(61, 66, 191, .08)" }}
            />
          </linearGradient>
        </defs>
        <path
          d={`M-1 -1 v${h} h${tw - 8} L${tw + 8} ${h * 0.64} H${w + 1} V-1 Z`}
          fill="url(#fillColor)"
          strokeWidth="2"
          stroke="url(#strokeColor)"
        />
        <path
          d={`M${tw + 16} ${h * 0.64 + 4} h32 l6 -8 h-32 Z`}
          fill="#7f6ad5"
        />
      </svg>
      <div className="relative flex">
        <div className="flex-none px-8 py-6" ref={titleRef}>
          <Link to="/">
            <div
              className="text-4xl leading-tight font-s color-text-gradient font-bold"
              style={{
                backgroundImage:
                  "linear-gradient(to top, #aaccf7 40%, #fff 60%)",
              }}
            >
              {mapName !== "全国" && Adcodes[mapName]
                ? mapName
                : "秒针系统-全域广告测量"}
            </div>
            <div className="text-sm color-white font-s">{time}</div>
          </Link>
        </div>
        <Swiper
          className="top-0 right-0"
          style={{ position: "absolute", width: "60%", height: "64%" }}
          {...swiperParams}
          onSwiper={(swiper) => setTimeout(() => swiper.update(), 2000)}
        >
          {appData?.dimension?.campaign_name?.map(({ name }) => (
            <SwiperSlide
              key={name}
              className="flex justify-end items-center px-8 text-sm color-white"
            >
              {name}
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </header>
  );
};

export default AppHeader;
